import React from 'react';
import classNames from 'classnames';

import Link from '@buyside/components/presentation/Link/link';

import { commentAttachmentsUrl } from '@buyside/util/urlHelper';
import { getFilepathExtension, getExtensionIcon } from '@buyside/util/fileHelper';
import { truncateText } from '@buyside/util/textHelpers';

import { Maybe } from '@interfaces/graphql-typings';

import styles from './commentAttachmentStyles.scss';

const truncationLength = 34;

const CommentAttachments: React.FC<{
  commentAttachments?: Maybe<
    ({
      id: string;
      fileName: string;
      customName: string | null;
    } | null)[]
  >;
}> = ({ commentAttachments }) => {
  if (!commentAttachments || !commentAttachments?.length) return null;

  return (
    <div className={styles.fileListArea}>
      <table>
        <thead>
          <tr>
            <th className={styles.fileListHeader} colSpan={2}>
              File Attachments
            </th>
          </tr>
        </thead>
        <tbody>
          {commentAttachments.map(file => {
            if (!file) return null;
            const { fileName, customName, id } = file;
            const fileExtension = getFilepathExtension(fileName);
            const FileIcon = getExtensionIcon(fileExtension);
            const truncatedName =
              fileName.length > truncationLength
                ? `${truncateText(fileName, truncationLength - 5)}.${fileExtension}`
                : fileName;

            return (
              <tr key={id}>
                <td className={classNames(styles.fileListItem, styles.fileName)}>
                  <Link to={commentAttachmentsUrl(id)} target="_blank">
                    <FileIcon className={styles.fileIcon} />
                    {truncatedName}
                  </Link>
                </td>
                {customName && <td className={styles.fileListItem}>{customName}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CommentAttachments;
